<!--关于我们-->
<template>
  <div class="about-us">
    <div class="about-us-wrap">
          <div><img src="../../static/images/usbj2.png" alt=""></div>
      <div class="container">
        <div class="page-caption">
          <h1 class="anders"></h1>
        </div>
<!--        <div class="about-introduction"
             v-html="companyInfo.aboutCompany"></div>
        <div class="paragraph-wrapper">
          <div class="item">
            <h4 class="item-title"><img src="../../static/images/ilogo5.png" alt="">联系我们</h4>
            <el-row class="row-indent">
              <el-col :span="24">
                <p>联系电话：{{companyInfo.tel}}</p>
                <p>公司地址：{{aboutUsInfo.address}}</p>
              </el-col>
              <div :span="12"></div>
            </el-row>
          </div>
        </div>-->
        <div class="page-caption">
          <div class="point"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import * as types from '../vuex/types/type';

export default {
  data () {
    return {
    };
  },
  computed: {
    ...mapGetters({
      productList: types.GET_PRODUCT_LIST,
      companyInfo: types.GET_COMPANY_INFO,
      aboutUsInfo: types.GET_ABOUT_US_DATA
    })
  },
  methods: {
    ...mapMutations({
      setProductList: types.SET_PRODUCT_LIST
    }),
    ...mapActions({
      getProductsInfo: types.GET_PRODUCTS_INFO,
      getAboutUsInfo: types.GET_ABOUT_US
    }),
    productListData (page) {
      this.getProductsInfo({
        pageCurrent: page,
        proCategoryValue: ''
      }).then((res) => {
        const resData = res.data;
        const result = res.data.data;

        if (Number(resData.code) === 0) {
          this.setProductList({
            isConcat: true,
            productList: result.productList
          });
        }
      });
    }
  },
  mounted () {
    this.productListData(1);
    this.productListData(2);
    this.getAboutUsInfo();
  },
};
</script>
<style lang="scss">
.about-us {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #fff;

  .container {
    width: 1170px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    .page-caption {
      position: relative;
      text-align: center;
      overflow: hidden;
      .anders {
        font-size: 36px;
        color: #1a4369;
        font-weight: 400;
        letter-spacing: 4px;
        font-family: "Anders";
      }

      .point {
        margin: 15px auto;
        width: 22px;
        height: 5px;
        background-color: #fff;
        border-radius: 2.5px;
      }

      .title {
        margin: 0;
        font-size: 24px;
        color: #1a4369;
        letter-spacing: 10px;
      }
    }

    .about-introduction {
      position: relative;
      margin: 20px auto 0 auto;
      font-size: 18px;
      color: #1a4369;

      width: 100%;
      color: #1a4369 !important;
      font-size: 18px;
      letter-spacing: 1px;
      font-family: "Microsoft YaHei";

      & p {
        font-size: 18px !important;
        color: #1a4369 !important;
        text-indent: 35px;
        line-height: 36px;
      }

      .text-indent {
        margin: 0;
        line-height: 2;
        text-indent: 2em;
        letter-spacing: 1px;
      }
    }

    .paragraph-wrapper {
      margin-left: 12px;
      padding-bottom: 30px;
      border: 1px solid #fff;
      font-size: 18px;
      color: #1a4369;

      .item {
        margin-top: 30px;
        margin-left: 36px;

        .item-title {
          position: relative;
          img{
            position: absolute;
            left: -48px;
          }

        }

        p {
              padding-top: 20px;
          margin: 0 0 10px;
          letter-spacing: 1px;
        }

        .row-indent {
          margin-left: 2rem;
          padding-top: 20px;
          .about-us-plist li {
            display: inline-block;
            float: left;
            width: 50%;
            margin: 0 0 10px;
            letter-spacing: 1px;
          }

          .about-us-blist li {
            display: inline-block;
            float: left;
            width: 25%;
            margin: 0 0 10px;
            letter-spacing: 1px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// AboutUs.vue?9e23916c